import React from 'react'
import Table from 'components/Table'
import CurrencyItem from 'components/CurrencyItem'
import ChartTabs from 'components/ChartTabs'
import { numberPercentFormatter, numberFormatter } from 'utils/formatters'
import LineChartContainer from 'containers/LineChartContainer'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'

export const CryptoCurrencyList = ({title, rates, mode, ...props}) => {
	const columns = [{
		dataField: 'id',
		text: 'ID',
		hidden: true
	}, {
		dataField: 'currency',
		text: 'Име на валута',
		headerAlign: 'left',
		formatter: (cell, row) => <CurrencyItem currency={cell} mode={mode} />,
		filterValue: (cell, row) => `${cell.name} ${cell.abbreviature}`
	}, {
		dataField: 'market_cap',
		text: 'Пазарен дял',
		headerAlign: 'right',
		align: 'right',
		headerStyle: () => {
			return { width: '170px' }
		}
	}, {
		dataField: 'conversion_value',
		text: 'Курс (BGN)',
		headerAlign: 'right',
		align: 'right',
		formatter: (cell, row) => numberFormatter({ value: cell, thousandSeparator: ' ' }),
		filterValue: (cell, row) => cell,
		headerStyle: () => {
			return { width: '150px' }
		}
	}, {
		dataField: 'volume',
		text: 'Обща Стойност (24ч)',
		headerAlign: 'right',
		align: 'right',
		headerStyle: () => {
			return { width: '180px' }
		}
	}, {
		dataField: 'daily_diff',
		text: 'Движение (24ч)',
		headerAlign: 'right',
		align: 'right',
		formatter: cell => numberPercentFormatter(cell),
		headerStyle: () => {
			return { width: '170px' }
		}
	}, {
		dataField: 'week_chart',
		text: '7дн. графика',
		headerAlign: 'right',
		align: 'right',
		headerStyle: () => {
			return { width: '170px' }
		},
		style: { padding: '12px 0 12px 24px' }
	}, {
		dataField: 'link',
		text: '',
		headerAlign: 'right',
		align: 'right',
		headerStyle: () => {
			return { width: '70px' }
		}
	}]

	const expandRow = {
		renderer: row => <ChartTabs currency={row.to_crypto_currency_id} mode={mode} {...props} />
	}

	const paginationSettings = {
		sizePerPage: 5,
	}

	return <Table
		title={title}
		data={rates.map(rate => ({
			...rate,
			conversion_value: parseFloat(rate.conversion_value).toFixed(2),
			currency: {
				name: rate.name,
				abbreviature: rate.abbreviature,
				flag: `${rate.flag}`
			},
			market_cap: rate.market_cap,
			volume: rate.volume,
			daily_diff: parseFloat(rate.daily_diff).toFixed(2),
			week_chart: <LineChartContainer currency={rate.to_crypto_currency_id} mode={mode} weekly tiny />,
			link: <Link to={`/cryptocurrencies/rates/${rate.abbreviature}`} className='u-text--cornflower u-underline'>Виж</Link>
		}))}
		columns={columns}
		expandRow={expandRow}
		headerClasses='u-text--manatee u-weight--normal'
		paginationSettings={paginationSettings}
		search
	/>
}

CryptoCurrencyList.propTypes = {
	title: PropTypes.string,
	rates: PropTypes.arrayOf(PropTypes.shape({
		conversion_value: PropTypes.string,
		name: PropTypes.string,
		abbreviature: PropTypes.string,
		flag: PropTypes.string,
		market_cap: PropTypes.string,
		volume: PropTypes.string,
		daily_diff: PropTypes.string,
		to_crypto_currency_id: PropTypes.number
	})),
	mode: PropTypes.string
}

export default CryptoCurrencyList
